
import api from "../../../../../api/api"



const getByVoucherId = (voucherId) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/voucher-out-item/"+voucherId).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const save = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/voucher-out-item",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const remove = (id) => {
    return new Promise((resolve, reject)=>{
        api.delete("erp/voucher-out-item/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}



const getSerialNumberByVoucherItemId = (voucherItemId) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/voucher-out-item/serial-number/"+voucherItemId).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const addSerialNumber = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/voucher-out-item/serial-number",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const removeSerialNumber = (id) => {
    return new Promise((resolve, reject)=>{
        api.delete("erp/voucher-out-item/serial-number/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const updateDescription = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/voucher-out-item/description",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const voucherOutItemServices = {
    
    getByVoucherId,
    save,
    remove,

    getSerialNumberByVoucherItemId,
    addSerialNumber,
    removeSerialNumber,
    
    updateDescription
}
export default voucherOutItemServices;